
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Prices from './components/Prices';
import HowWeWork from './components/HowWeWork';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CallButton from './components/CallButton';
import ScrollToTop from './components/ScrollToTop';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    // overflow-x-hidden: prevents horizontal scroll/"layout shift" on mobile caused by
    // animated/absolute elements or negative margins in some sections.
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Services />
      <Prices />
      <HowWeWork />
      <Reviews />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <CallButton />
      <ScrollToTop />
    </div>
  );
}
